<template>
  <div class="pricing-status">
    <div class="pricing-status__header">
      <b>Status:</b>
      <span
        class="pricing-status__label"
        :class="{
          'pricing-status__label_default': !hasCustomPrices,
          'pricing-status__label_custom': hasCustomPrices,
        }"
      >
        {{ hasCustomPrices ? 'Custom' : 'Default' }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ hasCustomPrices: boolean }>()
</script>

<style lang="scss" scoped>
.pricing-status {
  &__header {
    display: flex;
  }
  &__label {
    display: flex;
    align-items: center;
    margin-left: 16px;
    &::before {
      display: inline-block;
      content: '';
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin-right: 8px;
    }
    &_custom {
      &::before {
        background: #08a762;
      }
    }
    &_default {
      &:before {
        background: #cccccc;
      }
    }
  }
  &__update {
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 0;
    color: #757575;
    margin-top: 18.5px;
  }
  &__user {
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 0;
    color: #757575;
  }
}
</style>
